// Imports libraries
import React from "react";

// TRIAL BUTTON <a href="/trial"><button class="primary space" id="join">{text_home["page"]["options"]["trial"]}</button></a>

// Imports components
import Row from "../components/atoms/row";
import Top from "../components/organisms/top";
import Bottom from "../components/organisms/bottom";

// Accesses home page
export default
function Thanks
()
{
    return (
        <React.Fragment>
            
            <Top title="Thank you" hero="You successfully completed your Team 360 Questionnaire">
                <Row>
                    <a href="/"><button class="primary space" id="home">Go Home</button></a>
                </Row>
            </Top>

            <Bottom />

        </React.Fragment>
    );

}